import { axiosWithToken } from '../../../utils/axios';

// 起算時刻のリストを一括でBEから取得
export async function getGeeTileIds() {
  try {
    const res = await axiosWithToken.get(`/gee_tile_ids/`,) 
    const res_data = res.data as any;
    return res_data;
  } catch (error) {
    return null;
  }
}

// 指定されたassetIDが存在するかの確認
export async function checkAssetIdExistence({ assetIdList }: {assetIdList:string[]}) {
  try {
    const res = await getGeeTileIds()
    const calculatedTimeList = res.data.file_path
    // assetIDListの中からcalculatedTimeListに存在するものだけを抽出
    const existing_assets = assetIdList.filter(assetID => calculatedTimeList.includes(assetID))
    return existing_assets
    }  
   catch (error) {
    return null;
  }
}
